<template>
  <v-container grid-list-md fluid>
    <v-layout wrap justify-space-between>
      <v-flex xs12 sm2>
        <v-btn
          color="primary"
          @click="create"
          class="mb-4"
          :disabled="!hasCondominioAccess(entity, 'create')"
        >
          {{ this.translate("system.button.add.title") }}
          <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4>
        <v-layout justify-space-between align-left>
          <v-text-field
            append-icon="search"
            label="Pesquisar"
            v-model="search"
          ></v-text-field>
          <v-checkbox label="Apenas Ativos" v-model="apenasAtivos"/>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm1>
        <v-menu offset-y>
          <v-btn slot="activator" icon class="ml-2" title="Relatórios">
            <v-icon>description</v-icon>
          </v-btn>
          <v-list>
            <!-- PDF -->
            <v-list-tile @click="exportReport(1)">
              <v-list-tile-action>
                <v-icon color="red darken-1">picture_as_pdf</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Relatório em PDF</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <!-- Excel -->
            <v-list-tile @click="exportReport(2)">
              <v-list-tile-action>
                <v-icon color="green darken-2">table_chart</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>Relatório em Excel</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>

      <!--Index-->
      <v-flex xs12>
        <v-data-table
          ref="imovelExploradoTable"
          :headers="headers"
          :items="items"
          :search="search"
          :custom-filter="customFilter"
          class="elevation-1"
          :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.sequencia_ir }}</td>
            <td>{{ props.item.id_texto }}</td>
            <td>{{ getAtividadeText(props.item.atividade) }}</td>
            <td>{{ props.item.localizacao }}</td>
            <td>{{ props.item.nirf }}</td>
            <td align="right">{{ props.item.area | formatDouble }} ha</td>
            <td>{{ props.item.participacao | formatDouble }}</td>
            <td>{{ getExploracaoText(props.item.exploracao) }}</td>
            <td>
              <v-checkbox
                v-model="props.item.ativo"
                color="primary"
                @click.native="
                  editValue(entity, props.item.id, {
                    id: props.item['id'],
                    ativo: props.item['ativo'],
                  })
                "
              ></v-checkbox>
            </td>
            <td align="center" style="min-width: 150px">
              <v-btn
                icon
                class="mx-0"
                @click="editItem(props.item)"
                :disabled="!hasCondominioAccess(entity, 'update')"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                @click="deleteItem(props.item)"
                :disabled="!hasCondominioAccess(entity, 'delete')"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template v-slot:footer>
            <td colspan="6">
              <strong>Total Geral</strong>
            </td>
            <td align="right">
              <strong>{{ sum.area | formatDouble }} ha</strong>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de
            {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">{{ formTitle }}</span>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="id_texto"
                  v-model="editedItem.id_texto"
                  counter
                  maxlength="60"
                  v-validate="'required'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('id_texto')"
                  :data-vv-as="translate('table.' + entity + '.field.id_texto')"
                  :label="translate('table.' + entity + '.field.id_texto')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  name="sequencia_ir"
                  data-vv-validate-on="blur"
                  counter
                  maxlength="19"
                  v-model="editedItem.sequencia_ir"
                  v-validate="'required'"
                  @blur="checkDuplicate(items, 'sequencia_ir', editedItem.sequencia_ir)"
                  :error-messages="errors.collect('sequencia_ir')"
                  :data-vv-as="translate('table.' + entity + '.field.sequencia_ir')"
                  :label="translate('table.' + entity + '.field.sequencia_ir')"
                ></v-text-field>
                <div
                  style="color: #ff5252; font-size: 12px !important; position: relative; margin-top: -20px"
                  v-if="sequencia_ir_duplicated"
                >
                  Este valor já foi inserido anteriormente.
                </div>
              </v-flex>
              <v-flex xs12 md4>
                <v-autocomplete
                  name="atividade"
                  v-model="editedItem.atividade"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('atividade')"
                  :data-vv-as="translate('table.' + entity + '.field.atividade')"
                  :label="translate('table.' + entity + '.field.atividade')"
                  :items="translate('value.imovel_atividade')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  name="localizacao"
                  data-vv-validate-on="blur"
                  counter
                  maxlength="55"
                  v-model="editedItem.localizacao"
                  v-validate="'required|max:55'"
                  :error-messages="errors.collect('localizacao')"
                  :data-vv-as="translate('table.' + entity + '.field.localizacao')"
                  :label="translate('table.' + entity + '.field.localizacao')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  name="nirf"
                  v-model="editedItem.nirf"
                  counter
                  maxlength="8"
                  v-validate="'required|max:8'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('nirf')"
                  :data-vv-as="translate('table.' + entity + '.field.nirf')"
                  :label="translate('table.' + entity + '.field.nirf')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <p-money
                  name="area"
                  :label="translate('table.' + entity + '.field.area')"
                  v-model="editedItem.area"
                  :v_validate="'positiveNumber'"
                  custom_preffix="ha"
                  :custom_precision="1"
                ></p-money>
              </v-flex>
              <v-flex xs12 md6>
                <p-money
                  :label="translate('table.' + entity + '.field.participacao')"
                  v-model="editedItem.participacao"
                  custom_preffix="%"
                ></p-money>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  name="exploracao"
                  v-model="editedItem.exploracao"
                  data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('exploracao')"
                  :data-vv-as="translate('table.' + entity + '.field.exploracao')"
                  :label="translate('table.' + entity + '.field.exploracao')"
                  :items="translate('value.imovel_exploracao')"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  name="caepf"
                  :label="translate('table.' + entity + '.field.caepf')"
                  v-model="editedItem.caepf"
                  counter
                  maxlength="14"
                  :mask="'###.###.###/###-##'"
                ></v-text-field>
                <!-- v-validate="'required|validCAEPF'"
                  data-vv-validate-on="blur"
                  :data-vv-as="translate('table.' + entity + '.field.caepf')"
                  :error-messages="errors.collect('caepf')" -->
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  name="nirf"
                  v-model="editedItem.inscr_estadual"
                  counter
                  maxlength="14"
                  :label="translate('table.' + entity + '.field.inscr_estadual')"
                ></v-text-field>
                <!-- v-validate="'max:14'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('inscr_estadual')"
                  :data-vv-as="translate('table.' + entity + '.field.inscr_estadual')" -->
              </v-flex>
              <v-flex xs12 md4>
                <v-autocomplete
                  name="tipo_exploracao"
                  v-model="editedItem.tipo_exploracao"
                  :label="translate('table.' + entity + '.field.tipo_exploracao')"
                  :items="translate('value.controlecaixa_codigo_imovel')"
                ></v-autocomplete>
                  <!-- data-vv-validate-on="blur"
                  v-validate="'required'"
                  :error-messages="errors.collect('tipo_exploracao')"
                  :data-vv-as="translate('table.' + entity + '.field.tipo_exploracao')" -->
              </v-flex>
              <v-flex xs12 md2 style="align-self: center">
                <div>
                  <v-badge color="blue darken-1" overlap>
                    <span slot="badge">{{ terceiros.length }}</span>
                    <v-btn
                      color="secondary"
                      @click="openTerceiros()"
                      :disabled="!editedItem.id"
                      block
                    >
                      <v-icon left>group</v-icon>
                      Consulta de Terceiros
                    </v-btn>
                  </v-badge>
                  <p v-if="!editedItem.id" style="font-size: 11px; color: #999; margin-top: 4px;">
                    Salve o registro antes de gerenciar terceiros.
                  </p>
                </div>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  name="endereco"
                  v-model="editedItem.endereco"
                  counter
                  maxlength="100"
                  :label="translate('table.' + entity + '.field.endereco')"
                ></v-text-field>
                  <!-- v-validate="'required|max:100'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('endereco')"
                  :data-vv-as="translate('table.' + entity + '.field.endereco')" -->
              </v-flex>
              <v-flex xs12 md2>
                <v-text-field
                  name="numero"
                  v-model="editedItem.numero"
                  counter
                  maxlength="6"
                  :label="translate('table.' + entity + '.field.numero')"
                ></v-text-field>
                  <!-- v-validate="'max:6'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('numero')"
                  :data-vv-as="translate('table.' + entity + '.field.numero')" -->
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  name="complemento"
                  v-model="editedItem.complemento"
                  counter
                  maxlength="50"
                  :label="translate('table.' + entity + '.field.complemento')"
                ></v-text-field>
                <!-- v-validate="'max:50'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('complemento')"
                  :data-vv-as="translate('table.' + entity + '.field.complemento')" -->
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  name="cidade_id"
                  v-model="editedItem.cidade_id"
                  :label="translate('table.' + entity + '.field.cidade_id')"
                  :items="cidades"
                  item-text="id_texto"
                  item-value="id"
                ></v-autocomplete>
                  <!-- v-validate="'required'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('cidade_id')"
                  :data-vv-as="translate('table.' + entity + '.field.cidade_id')" -->
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  name="bairro"
                  v-model="editedItem.bairro"
                  counter
                  maxlength="50"
                  :label="translate('table.' + entity + '.field.bairro')"
                ></v-text-field>
                  <!-- v-validate="'required|max:50'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('bairro')"
                  :data-vv-as="translate('table.' + entity + '.field.bairro')" -->
              </v-flex>
              <v-flex xs12 md3>
                <v-text-field
                  name="cep"
                  v-model="editedItem.cep"
                  :mask="'#####-###'"
                  counter
                  maxlength="8"
                  :label="translate('table.' + entity + '.field.cep')"
                ></v-text-field>
                  <!-- v-validate="'required|max:8'"
                  data-vv-validate-on="blur"
                  :error-messages="errors.collect('cep')"
                  :data-vv-as="translate('table.' + entity + '.field.cep')" -->
              </v-flex>
              <v-flex xs12>
                <v-switch
                  color="primary"
                  :label="translate('table.' + entity + '.field.ativo')"
                  v-model="editedItem.ativo"
                ></v-switch>
              </v-flex>
              <v-flex xs12>
                <v-btn class="mx-1" color="primary darken-2" :disabled="saving" :loading="saving" @click.native="save()">Salvar</v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal: Consulta de Terceiros -->
    <v-dialog v-model="terceirosDialog" max-width="900px">
      <v-card>
        <v-card-title>
          <span class="headline">Consulta de Terceiros</span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap justify-space-between align-center>
            <v-flex xs12 sm3>
              <v-btn color="primary" @click="openTerceirosForm()">
                Adicionar
                <v-icon right>add</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 sm5>
              <v-text-field
                append-icon="search"
                label="Pesquisar"
                v-model="terceirosSearch"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-data-table
                :headers="terceirosHeaders"
                :items="terceiros"
                :search="terceirosSearch"
                class="elevation-1"
                no-data-text="Não existem registros"
                no-results-text="Nenhum registro encontrado"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.nome }}</td>
                  <td>{{ props.item.cpf_cnpj | formatCpfCnpj }}</td>
                  <td>{{ getTipoParticipanteText(props.item.tipo_participante) }}</td>
                  <td align="center">
                    <v-btn icon class="mx-0" @click="openTerceirosForm(props.item)">
                      <v-icon color="teal">edit</v-icon>
                    </v-btn>
                    <v-btn icon class="mx-0" @click="deleteTerceiro(props.item)">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </td>
                </template>
                <template slot="pageText" slot-scope="props">
                  {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="terceirosDialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal: Adicionar / Editar Terceiro -->
    <v-dialog v-model="terceirosFormDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ terceirosEditedIndex === -1 ? 'Adicionar Terceiro' : 'Editar Terceiro' }}</span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                :label="translate('table.condominio_imovelexplorado_terceiros.field.nome')"
                v-model="terceirosEditedItem.nome"
                counter
                maxlength="100"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <p-cpf-cnpj
                :label="translate('table.condominio_imovelexplorado_terceiros.field.cpf_cnpj')"
                v-model="terceirosEditedItem.cpf_cnpj"
              ></p-cpf-cnpj>
            </v-flex>
            <v-flex xs12>
              <v-select
                :label="translate('table.condominio_imovelexplorado_terceiros.field.tipo_participante')"
                v-model="terceirosEditedItem.tipo_participante"
                :items="tipoParticipanteOptions"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary darken-2" :disabled="saving" :loading="saving" @click="saveTerceiro()">Salvar</v-btn>
          <v-btn @click="terceirosFormDialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import crud from "./../../mixin/crud";
import Helper from "./../../classes/helper";
import PMoney from "../shared/PMoney";
import acl from "./../../mixin/acl";
import PCpfCnpj from "../shared/PCpfCnpj";

export default {
  components: {
    PMoney,
    PCpfCnpj,
  },
  mixins: [crud, acl],
  data: () => ({
    entity: "condominio_imovelexplorado",
    items: [],
    cidades: [],
    sum: {
      area: 0,
    },
    sequencia_ir_duplicated: false,
    apenasAtivos: true,
    // Terceiros
    terceirosDialog: false,
    terceirosFormDialog: false,
    terceiros: [],
    terceirosSearch: '',
    terceirosEditedIndex: -1,
    terceirosEditedItem: { nome: '', cpf_cnpj: '', tipo_participante: null },
    terceirosDefaultItem: { nome: '', cpf_cnpj: '', tipo_participante: null },
    tipoParticipanteOptions: [
      { value: 1, text: '1 - Condômino' },
      { value: 2, text: '2 - Arrendador' },
      { value: 3, text: '3 - Parceiro' },
      { value: 4, text: '4 - Comodante' },
      { value: 5, text: '5 - Outros' },
    ],
  }),
  name: "ImovelExplorado",
  props: ["condominio_id", "values", "initials"],
  created() {
    this.items = this.values;
    this.editedItem = { condominio_id: this.condominio_id, ativo: true };
    this.defaultItem = { condominio_id: this.condominio_id, ativo: true };
    this.$store.commit("loader/change_dialog", false);
    this.$http
      .get(
        `api/cidade?select=id,CONCAT(id_texto, ' - ', uf) as id_texto ,cidade_id,uf&order=id_texto asc`
      )
      .then(
        (res) => {
          this.cidades = res.body.dados;
          this.$store.commit("loader/change_dialog", false);
        },
        () => this.$store.commit("loader/change_dialog", false)
      );
  },
  computed: {
    terceirosHeaders() {
      const t = 'table.condominio_imovelexplorado_terceiros.field';
      return [
        { text: this.translate(`${t}.nome`),              value: 'nome' },
        { text: this.translate(`${t}.cpf_cnpj`),          value: 'cpf_cnpj' },
        { text: this.translate(`${t}.tipo_participante`),  value: 'tipo_participante' },
        { text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center', width: '15%' },
      ];
    },
    headers: function () {
      return [
        {
          text: this.translate("table." + this.entity + ".field.sequencia_ir"),
          value: "sequencia_ir",
          width: "10%",
        },
        {
          text: this.translate("table." + this.entity + ".field.id_texto"),
          value: "id_texto",
          width: "30%",
        },
        {
          text: this.translate("table." + this.entity + ".field.atividade"),
          value: "atividade",
          width: "5%",
        },
        {
          text: this.translate("table." + this.entity + ".field.localizacao"),
          value: "localizacao",
          width: "15%",
        },
        {
          text: this.translate("table." + this.entity + ".field.nirf"),
          value: "nirf",
          width: "7%",
        },
        {
          text: this.translate("table." + this.entity + ".field.area"),
          value: "area",
          width: "5%",
          align: "right",
        },
        {
          text: this.translate("table." + this.entity + ".field.participacao"),
          value: "participacao",
          width: "5%",
        },
        {
          text: this.translate("table." + this.entity + ".field.exploracao"),
          value: "exploracao",
          width: "5%",
        },
        {
          text: this.translate("table." + this.entity + ".field.ativo"),
          value: "ativo",
          width: "5%",
        },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
          width: "10%",
        },
      ];
    },
  },
  methods: {
    customFilter(items, search, filter) {
      let filteredItems = items;

      // Filtro de pesquisa geral (em todos os campos)
      if (search) {
        filteredItems = filteredItems.filter(item => {
          // Verifica se o termo de pesquisa está em qualquer campo do item
          return Object.values(item)
            .toString()
            .toLowerCase()
            .includes(search.toLowerCase());
        });
      }
      // Filtro de ativo
      if (this.apenasAtivos) {
        filteredItems = filteredItems.filter(item => item.ativo == true);
      }
      this.updateSum(filteredItems);
      return filteredItems;
    },
    checkDuplicate(items, index, value) {
      // this.sequencia_ir_duplicated = items.find((item) => {
      //   return item[index] === value;
      // });
      // if (this.sequencia_ir_duplicated) {
      //   event.preventDefault();
      //   event.target.select();
      // }
    },
    beforeCreate() {
      this.editedItem.sequencia_ir = Helper.generateSequenciaIr(this.initials, "IE", this.values);
      this.terceiros = [];
    },
    updateSum(filteredItems) {
      this.sum.area = filteredItems
        .reduce((acumulador, objeto) => acumulador + objeto.area, 0)
        .toFixed(2);
    },
    getExploracaoText (atividade) {
      const translate = 'value.imovel_exploracao'
      const item = this.translate(translate).find(c => c.value === atividade)
      return item ? item.text : ''
    },
    getAtividadeText (exploracao) {
      const translate = 'value.imovel_atividade'
      const item = this.translate(translate).find(c => c.value === exploracao)
      return item ? item.text : ''
    },
    afterEdit() {
      this.terceiros = [];
      if (this.editedItem.id) {
        this.$http
          .get(`api/condominio_imovelexplorado_terceiros?where=condominio_imovelexplorado_id=${this.editedItem.id}`)
          .then(
            (res) => { this.terceiros = res.body.dados; },
            () => {}
          );
      }
    },
    // Terceiros
    getTipoParticipanteText(value) {
      const opt = this.tipoParticipanteOptions.find(o => o.value === value);
      return opt ? opt.text : (value || '');
    },
    openTerceiros() {
      this.terceirosSearch = '';
      this.terceirosDialog = true;
    },
    openTerceirosForm(item) {
      if (item) {
        this.terceirosEditedIndex = this.terceiros.indexOf(item);
        this.terceirosEditedItem  = Object.assign({}, item);
      } else {
        this.terceirosEditedIndex = -1;
        this.terceirosEditedItem  = Object.assign({}, this.terceirosDefaultItem);
      }
      this.terceirosFormDialog = true;
    },
    saveTerceiro() {
      if (this.saving) return;
      this.saving = true;
      this.$store.commit('loader/change_dialog', true)

      const payload = Object.assign({}, this.terceirosEditedItem, {
        condominio_imovelexplorado_id: this.editedItem.id,
      });
      if (this.terceirosEditedIndex === -1) {
        this.$http.post('api/condominio_imovelexplorado_terceiros', payload).then(
          (res) => {
            this.saving = false;
            this.$store.commit('loader/change_dialog', false)
            this.terceiros.push(res.body.dados);
            this.terceirosFormDialog = false;
          },
          () => {
            this.saving = false;
            this.$store.commit('loader/change_dialog', false)
          }
        );
      } else {
        this.$http.put(`api/condominio_imovelexplorado_terceiros/${payload.id}`, payload).then(
          (res) => {
            this.saving = false;
            this.$store.commit('loader/change_dialog', false)
            Object.assign(this.terceiros[this.terceirosEditedIndex], res.body.dados);
            this.terceirosFormDialog = false;
          },
          () => {
            this.saving = false;
            this.$store.commit('loader/change_dialog', false)
          }
        );
      }
    },
    deleteTerceiro(item) {
      if (!confirm('Deseja excluir este registro?')) return;
      this.$store.commit('loader/change_dialog', true)

      this.$http.delete(`api/condominio_imovelexplorado_terceiros/${item.id}`).then(
        () => {
          this.$store.commit('loader/change_dialog', false)
          const index = this.terceiros.indexOf(item);
          this.terceiros.splice(index, 1);
        },
        () => {
          this.$store.commit('loader/change_dialog', false)
        }
      );
    },
    // type 1 = pdf 2 = excel
    exportReport (type) {
      this.$store.commit("loader/change_dialog", true);
      this.$http.put(`report/report_details/${this.condominio_id}`, {"type": type, "table": "condominio_imovelexplorado", "search": this.search, "apenasAtivos": this.apenasAtivos}).then(
        (res) => {
          let fileName = res.data;
          window.open(process.env.API + "reports/" + fileName, "_blank");
          this.$store.commit("loader/change_dialog", false);
          setTimeout(function () {
            _this.$http.delete(`report/delete_upload_report/${fileName}`)
          }, 5000)
        },
        (error) => {
          this.$store.commit("loader/change_dialog", false);
          this.$store.commit("snackbar/change_values", {
            text:
              error.body.message ||
              "Desculpe, não conseguimos gerar o relatório no momento. Por favor, tente novamente mais tarde.",
            color: "error",
            dialog: true,
          });
        }
      );
    }
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/details/ImovelExplorado.vue